import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs md:text-sm">
      <ol className="flex flex-wrap items-center gap-2">
        {items.map((item, idx) => {
          const last = idx === items.length - 1;
          return (
            <li key={`${item.label}-${idx}`} className="flex items-center gap-2">
              {item.to && !last ? (
                <Link
                  to={item.to}
                  className="text-foreground-500 hover:text-primary-600 transition-colors"
                >
                  {item.label}
                </Link>
              ) : (
                <span className={last ? 'text-foreground-800' : 'text-foreground-500'}>
                  {item.label}
                </span>
              )}
              {!last && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}